'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var parseDuration = require('parse-duration');

var errCode = require('err-code');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var parseDuration__default = /*#__PURE__*/_interopDefaultLegacy(parseDuration);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function getBandwidthStats(libp2p, opts) {
  var stats;

  if (!libp2p.metrics) {
    stats = undefined;
  } else if (opts.peer) {
    stats = libp2p.metrics.forPeer(opts.peer);
  } else if (opts.proto) {
    stats = libp2p.metrics.forProtocol(opts.proto);
  } else {
    stats = libp2p.metrics.global;
  }

  if (!stats) {
    return {
      totalIn: BigInt(0),
      totalOut: BigInt(0),
      rateIn: 0,
      rateOut: 0
    };
  }

  var _stats = stats,
      movingAverages = _stats.movingAverages,
      snapshot = _stats.snapshot;
  return {
    totalIn: BigInt(snapshot.dataReceived.integerValue().toString()),
    totalOut: BigInt(snapshot.dataSent.integerValue().toString()),
    rateIn: movingAverages.dataReceived[60000].movingAverage() / 60,
    rateOut: movingAverages.dataSent[60000].movingAverage() / 60
  };
}

function createBw(_ref2) {
  var network = _ref2.network;

  var bw = /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          _yield$_awaitAsyncGen,
          libp2p,
          interval,
          ms,
          timeoutId,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.next = 3;
              return _awaitAsyncGenerator(network.use(options));

            case 3:
              _yield$_awaitAsyncGen = _context.sent;
              libp2p = _yield$_awaitAsyncGen.libp2p;

              if (options.poll) {
                _context.next = 9;
                break;
              }

              _context.next = 8;
              return getBandwidthStats(libp2p, options);

            case 8:
              return _context.abrupt("return");

            case 9:
              interval = options.interval || 1000;
              ms = -1;
              _context.prev = 11;
              ms = typeof interval === 'string' ? parseDuration__default["default"](interval) || -1 : interval;

              if (!(!ms || ms < 0)) {
                _context.next = 15;
                break;
              }

              throw new Error('invalid duration');

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](11);
              throw errCode__default["default"](_context.t0, 'ERR_INVALID_POLL_INTERVAL');

            case 20:
              _context.prev = 20;

            case 21:
              if (!true) {
                _context.next = 28;
                break;
              }

              _context.next = 24;
              return getBandwidthStats(libp2p, options);

            case 24:
              _context.next = 26;
              return _awaitAsyncGenerator(new Promise(function (resolve) {
                timeoutId = setTimeout(resolve, ms);
              }));

            case 26:
              _context.next = 21;
              break;

            case 28:
              _context.prev = 28;
              clearTimeout(timeoutId);
              return _context.finish(28);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 17], [20,, 28, 31]]);
    }));

    return function bw() {
      return _ref.apply(this, arguments);
    };
  }();

  return withTimeoutOption.withTimeoutOption(bw);
}

exports.createBw = createBw;